import normalizeWheel from "normalize-wheel";

// https://remysharp.com/2010/07/21/throttling-function-calls
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function() {
    var context = scope || this;

    var now = +new Date(),
      args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function() {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

function toPercent(n) {
  return n * 100 + "%";
}

// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
// Test via a getter in the options object to see if the passive property is accessed
const supportsPassiveEvents = false;
// try {
//   let opts = Object.defineProperty({}, "passive", {
//     get:()=> {
//       supportsPassiveEvents = true;
//     },
//   });
//   window.addEventListener("test", null, opts);
// } catch (e) {
//   
// }

const supportsMutationObserver = "MutationObserver" in window;

export {
  throttle,
  toPercent,
  normalizeWheel,
  supportsPassiveEvents,
  supportsMutationObserver,
};
